import UniqueQuestion from './UniqueQuestion';

export default UniqueQuestion;
